module.exports = __webpack_public_path__ + "static/poster-3-3aaa22dd9019bd1333205173dc5cf490.jpg";